module.exports = __webpack_public_path__ + "img/payment_datafono.dfff42a1.png";